import React from "react"
import FullWidthImage from "../../components/full-width-image/full-width-image"

export default ({ slice }) => {
  const { imageSharp } = slice.primary
  return <FullWidthImage image={imageSharp} />
}
